<template>
  <v-dialog v-model="showDialog" transition="dialog-top-transition" :max-width="maxWidth">
    <v-card data-cy="dialog-confirm">
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text v-html="message" />
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="cancelButtonVisible"
          class="ma-2"
          size="large"
          variant="outlined"
          :color="cancelButton.color"
          @click.stop="cancelClick()"
        >
          {{ cancelButton.text }}
        </v-btn>
        <v-btn
          variant="flat"
          v-if="confirmButtonVisible"
          size="large"
          data-cy="confirm-button"
          :color="confirmButton.color"
          @click.stop="confirmClick()"
        >
          {{ confirmButton.text }}
        </v-btn>
      </v-card-actions>
      <v-checkbox class="small-checkbox ml-5" v-if="option" v-model="optionChecked" density="compact" :label="option" />
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

const emit = defineEmits(['confirmClick', 'cancelClick', 'close']);
const props = withDefaults(
  defineProps<{
    dialogVisible?: boolean;
    confirmButtonVisible?: boolean;
    cancelButtonVisible?: boolean;
    title?: string;
    message?: string;
    confirmButton?: { text: string; color: string };
    cancelButton?: { text: string; color: string };
    maxWidth?: number;
    option?: string;
  }>(),
  {
    dialogVisible: false,
    confirmButtonVisible: true,
    cancelButtonVisible: true,
    title: 'Are you sure?',
    message: 'Are you sure that you want to delete this item?',
    confirmButton: () => ({ text: 'Yes', color: 'error' }),
    cancelButton: () => ({ text: 'No', color: 'gray' }),
    maxWidth: 400,
    option: undefined,
  },
);
const showDialog = computed<boolean>({
  get: () => props.dialogVisible,
  set: value => {
    if (!value) {
      emit('close');
    }
  },
});
const optionChecked = ref(false);

const closeDialog = (): void => {
  showDialog.value = false;
};
const cancelClick = (): void => {
  if (props.option) {
    emit('cancelClick', optionChecked.value);
  }
  closeDialog();
};
const confirmClick = (): void => {
  emit('confirmClick', optionChecked.value);
  closeDialog();
};
</script>
<style scoped>
.small-checkbox :deep(.v-selection-control) {
  --v-selection-control-size: 30px;
}

.small-checkbox :deep(.v-icon) {
  font-size: 16px;
}

.small-checkbox :deep(.v-label) {
  line-height: 1.3;
  font-size: 0.8rem;
}
</style>
